import { useState, useEffect } from 'react';

/**
 * Custom hook for managing color scheme with localStorage persistence
 * @returns {Object} { colorScheme, setColorScheme }
 */
export const useColorScheme = () => {
  const [colorScheme, setColorSchemeState] = useState(() => {
    const saved = localStorage.getItem('backgroundColorScheme');
    return saved || 'orange'; // default to orange
  });

  const setColorScheme = (newScheme) => {
    setColorSchemeState(newScheme);
    localStorage.setItem('backgroundColorScheme', newScheme);
  };

  useEffect(() => {
    // Listen for storage changes from other tabs/windows
    const handleStorageChange = (e) => {
      if (e.key === 'backgroundColorScheme' && e.newValue) {
        setColorSchemeState(e.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return { colorScheme, setColorScheme };
};
